import StyledListContainer from "containers/ListContainer/ListContainer";
import StyledPagination from "containers/Pagination/Pagination.styled";

const Board = () => {
  return (
    <>
      <StyledListContainer />
      <StyledPagination />
    </>
  );
};

export default Board;
